
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { Qcdefectdto } from './qc-defect.dto';

export class AllQcDefectResponseModel extends GlobalResponseObject {

    data?: Qcdefectdto[];
     /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */

      constructor(status: boolean, intlCode: number, internalMessage: string, data?: Qcdefectdto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}